<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"
         :width="width"
         :height="height"
         :stroke-width="strokeWidth"
         :stroke="color"
    >
        <slot />
    </svg>
</template>

<script setup>
const props = defineProps({
    width: {type: [Number, String], default: 24},
    height: {type: [Number, String], default: 24},
    strokeWidth: {type: [Number, String], default: 2},
    color: {type: String, default: 'currentColor'}
})
</script>
